
<div class="card py-10 ">

  <div class="text-left" *ngIf="isCompleted">
    <h1 class="text-3xl text-bold pb-1">Password cambiata</h1>
    <h4 class="text-1xl text-bold pb-5">Torna al login</h4>
    <div class=" mt-6">
      <button ejs-button class="e-primary transform duration-300"
        (click)="route()">
        Vai al Login
      </button>
    </div>
  </div>

  <div class="text-left" *ngIf="!isCompleted">

    <button routerLink="/auth/login" ejs-button
      class="dl-button h-8 mb-5">
      <svg viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
      </svg>
    </button>

    <div class="w-full flex flex-col items-center justify-center">
      <div class="text-center w-full">
        <h2 class=" text-bold ">Reset password</h2>
        <h5 class=" text-bold ">Inserisci la nuova password che vuoi utilizzare</h5>
      </div>

      <div [formGroup]="formReset" class="w-10/12">

        <label for="pwdInput" class="text-gray-500">Password</label><br />
        <div class="relative mb-3">
          <div class="relative">
          <input #pwdInput id="pwdInput" type="password"
            formControlName="password"
            (keyup)="pwdValidation(pwdInput.value)"
            class="e-input transform duration-300"
            placeholder="Inserisci la password " />
  
          <div [class]="passwIcon"
            class="absolute top-0 bottom-0 right-0 pwdicon flex content-center justify-center items-center align-middle"
            (click)="showPassword()">
          </div>
        </div>
  
          <h5 class="text-xs font-light text-slate-400 pwtext">La password deve
            avere almeno 8 caratteri, un
            numero e un carattere speciale</h5>
          <ejs-message class="msg" severity="Error" [visible]="pwdNotValid"
            [content]="'La password non è valida'"></ejs-message>
        </div>
  
        <label for="pwdInputConfirm" class="text-gray-500">Conferma la password</label><br />
        <div class="relative mb-5">
          <div class="relative">
            <input #pwdInputConfirm id="pwdInputConfirm" type="password"
              formControlName="passwordConfirm"
              class="e-input transform duration-300"
              (keyup)="pwdCheck(pwdInputConfirm.value)"
              placeholder="Inserisci la password " />
              <div [class]="passwIcon"
              class="absolute top-0 bottom-0 right-0 pwdicon flex content-center justify-center items-center align-middle"
              (click)="showPassword()">
            </div>
          </div>
          

          <ejs-message class="msg mt-2" severity="Error" [visible]="!pwdError"
            [content]="'Le password non combaciano'"></ejs-message>
  
        </div>
  
        <div class="relative mt-6">
          <button ejs-button class="e-primary transform duration-300"
            (click)="resetPwd();" type="submit"
            [disabled]="formReset.invalid">
            Conferma
          </button>
        </div>
  
        <ejs-message class="msg" severity="Error" [visible]="formHaveErrors"
          [content]="errMsg"></ejs-message>
  
        <ejs-message *ngIf="rispSignUp" class="msg" severity="Error"
          [visible]="!rispSignUp.success"
          [content]="rispSignUp.error"></ejs-message>
  
      </div>
    </div>
  </div>
</div>